import { render, staticRenderFns } from "./DoctorAppLayout.vue?vue&type=template&id=172e5c22&scoped=true"
import script from "./DoctorAppLayout.vue?vue&type=script&lang=js"
export * from "./DoctorAppLayout.vue?vue&type=script&lang=js"
import style0 from "./DoctorAppLayout.vue?vue&type=style&index=0&id=172e5c22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e5c22",
  null
  
)

export default component.exports